import { FormControl, FormGroup } from '@angular/forms';

export enum BulkCardIssuanceStatus {
    DRAFT = 'DRAFT',
    COMPLETED = 'COMPLETED',
    SUBMITTED = 'SUBMITTED',
    CANCELLED = 'CANCELLED',
    PROCESSING = 'PROCESSING',
}

export enum BulkCardIssuanceCardType {
    PHYSICAL = 'PHYSICAL',
    VIRTUAL = 'VIRTUAL',
}

export interface IBulkCardIssuance {
    id: string;
    card_product_id: string;
    number_of_cards: number;
    status: BulkCardIssuanceStatus;
    created: string;
    card_type?: BulkCardIssuanceCardType;
    name_on_card?: string;
    card_validity_term?: number;
    extra_embossing_line?: string;
    amount?: number;
    currency?: string;
    shipping_details?: IBulkCardIssuanceShippingDetails;
}

export interface IBulkCardIssuanceListResponse {
    data: IBulkCardIssuance[];
    after: string;
    has_more: boolean;
}

export interface IBulkCardIssuanceFilters {
    status: BulkCardIssuanceStatus;
    file_name: string;
}

export interface IBulkCardIssuanceQueryParams {
    limit: number;
    after: string;
    status: BulkCardIssuanceStatus;
    file_name: string;
    from_date: string;
    to_date: string;
    sort_by: string;
    order_by: string;
}

export interface IBulkCardIssuanceShippingAddress {
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    mobile?: string;
    address_line1?: string;
    address_line2?: string;
    city?: string;
    state?: string;
    country?: string;
    postal_code?: string;
    province?: string;
    district?: string;
    street?: string;
    building?: string;
    nearest_place?: string;
}

export interface IBulkCardIssuanceShippingDetails {
    method: 'COURIER';
    shipping_address?: IBulkCardIssuanceShippingAddress;
    return_address?: IBulkCardIssuanceShippingAddress;
}

export interface IBulkCardIssuanceCreateRequest {
    card_product_id: string;
    number_of_cards: number;
    status: BulkCardIssuanceStatus.DRAFT | BulkCardIssuanceStatus.SUBMITTED;
    dry_run: false;
    card_type?: BulkCardIssuanceCardType;
    name_on_card?: string;
    card_validity_term?: number;
    extra_embossing_line?: string;
    amount?: number;
    currency?: string;
    shipping_details?: IBulkCardIssuanceShippingDetails;
}

export type IShippingAddressForm = {
    [K in keyof Required<IBulkCardIssuanceShippingAddress>]: FormControl<string>;
};

export type ICreateBulkCardForm = {
    card_product_id: FormControl<string>;
    number_of_cards: FormControl<number | null>;
    card_type: FormControl<BulkCardIssuanceCardType>;
    name_on_card: FormControl<string>;
    card_validity_term: FormControl<number | null>;
    extra_embossing_line: FormControl<string>;
    amount: FormControl<number | null>;
    currency: FormControl<string>;
    shipping_address: FormGroup<IShippingAddressForm>;
    return_address: FormGroup<IShippingAddressForm>;
};
